import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { useConfig } from "../_util/config-context";
var ModalMessageIconMap = {
    error: React.createElement(Icon, { type: "error", size: 32 }),
    warning: React.createElement(Icon, { type: "warning", size: 32 }),
    infoblue: React.createElement(Icon, { type: "infoblue", size: 32 }),
    pending: React.createElement(Icon, { type: "pending", size: 32 }),
    success: React.createElement(Icon, { type: "success", size: 32 }),
};
export var ModalMessage = React.forwardRef(function ModalMessage(_a, ref) {
    var icon = _a.icon, message = _a.message, description = _a.description, className = _a.className, props = __rest(_a, ["icon", "message", "description", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-media", className) }, props),
        icon && (React.createElement("div", { className: classPrefix + "-media__left" }, ModalMessageIconMap[icon] || React.createElement(Icon, { type: icon, size: "l" }))),
        React.createElement("div", { className: classPrefix + "-media__body" },
            message && (React.createElement("h3", { className: classPrefix + "-dialog__messagetitle" }, message)),
            description && (React.createElement("div", { className: classPrefix + "-dialog__messagetext" }, description)))));
});
ModalMessage.displayName = "ModalMessage";
//# sourceMappingURL=ModalMessage.js.map